/**
 * @fileOverview The one place that knows how many games the site has.
 *
 * Public copy used to hard-code the number in a dozen places and drift apart:
 * as of 2026-08-30 the same site was advertised as "30+ party games" on
 * /create-lobby and /tutorial and "45+ party games" on the Jackbox, Skribbl and
 * Gartic Phone pages, while the library actually held 48. Every one of those
 * claims is now derived from here.
 *
 * Deliberately dependency-free: it is imported by client-reachable modules
 * (src/lib/lang-seo.ts, which the footer pulls in), and importing the real
 * library would drag the whole game list and its icon imports into the client
 * bundle. `game-count.test.ts` asserts the literal below still matches
 * PUBLIC_GAME_LIBRARY_CONTENT, so it cannot silently go stale.
 *
 * This counts games a visitor can actually open: tester-gated games
 * (TESTER_ONLY_BY_DEFAULT in feature-flag-defaults.ts) are excluded until
 * their flag ships. The 2026-09-01 audit found the old value counted 7
 * tester-gated games, so "50+ games" was claimed while 45 were playable.
 */

/** Exact number of games in PUBLIC_GAME_LIBRARY_CONTENT (playable, not total). */
export const PUBLIC_GAME_COUNT = 57;

/**
 * The number to put in marketing copy, rounded DOWN to the nearest five.
 *
 * Rounding down means the "45+ games" claim is always true even in the window
 * between adding a game and updating this file, and it changes rarely enough
 * that translated copy does not need re-translating on every release.
 */
export const PUBLIC_GAME_COUNT_CLAIM = Math.floor(PUBLIC_GAME_COUNT / 5) * 5;

/** "45+" - the token that goes straight into a sentence. */
export const GAME_COUNT_CLAIM = `${PUBLIC_GAME_COUNT_CLAIM}+`;
